module.exports = __webpack_public_path__ + "img/calendar.4863074.svg";